"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteModule = void 0;
const react_1 = __importStar(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const module_federation_1 = require("@invent/module-federation");
const utils_1 = require("../../utils");
const styled_1 = require("./styled");
const error_boundary_component_1 = require("../error-boundary-component");
const fallbacks_1 = require("../fallbacks");
const utils_2 = require("../../utils");
const use_platform_meta_1 = require("../../utils/use-platform-meta");
const shared_state_1 = require("../../utils/shared-state");
const dashboard_navigation_1 = require("../../utils/dashboard-navigation");
const notifications_1 = require("../../utils/notifications");
const extensions_1 = require("../../utils/extensions");
exports.RemoteModule = (0, react_1.memo)(({ url, scope, module, dashboardWidgetInstanceId, componentProps = {}, fallback }) => {
    const platformMeta = (0, use_platform_meta_1.usePlatformMeta)();
    const moduleState = (0, module_federation_1.useModuleByNameSelector)(scope);
    const httpClient = (0, utils_1.useHttpClient)();
    const { getExtension, getExtensionsList } = (0, extensions_1.useExtensionsContext)();
    (0, module_federation_1.useInstanceCleanup)({ url, scope });
    const LazyComponent = (0, react_1.useMemo)(() => react_1.default.lazy((0, module_federation_1.loadComponent)(scope, module, url)), [scope, module, url]);
    const { status, error } = moduleState || {};
    (0, react_1.useEffect)(() => {
        var _a;
        if (status === 'failed' && ((_a = window === null || window === void 0 ? void 0 : window.sharedHostGateway) === null || _a === void 0 ? void 0 : _a.logger)) {
            window.sharedHostGateway.logger.error(String(error), {
                message: 'Cannot load widget.',
                tags: {
                    origin: window.location.origin,
                    environment: process.env.NODE_ENV,
                    scope,
                    url
                }
            });
        }
    }, [status]);
    const Failed = fallback === null || fallback === void 0 ? void 0 : fallback.failed;
    const Loading = fallback === null || fallback === void 0 ? void 0 : fallback.isLoading;
    const widgetDataGenerator = (0, react_1.useCallback)((name, widgetId) => {
        const widgetDataGeneratorWithPlatformCtx = (0, utils_2.generateWidgetData)(platformMeta);
        return widgetDataGeneratorWithPlatformCtx(name, widgetId);
    }, [platformMeta]);
    if (status === 'failed') {
        return Failed ? (react_1.default.createElement(Failed, Object.assign({}, componentProps))) : (react_1.default.createElement(fallbacks_1.ErrorFallbackCopyClipboard, { title: "Cannot load widget.", error: error }));
    }
    const loading = Loading ? (react_1.default.createElement(Loading, null)) : (react_1.default.createElement(styled_1.FallbackContainer, null,
        react_1.default.createElement(wl_ui_kit_1.Button, { text: "button", variant: "text", isLoading: true })));
    return (react_1.default.createElement(error_boundary_component_1.ErrorBoundaryWidgetComponent, { url: url, scope: scope, location: "remote-module" },
        react_1.default.createElement(react_1.default.Suspense, { fallback: loading },
            react_1.default.createElement(LazyComponent, Object.assign({ httpClient: httpClient, platformMeta: platformMeta }, componentProps, { useShareValue: shared_state_1.useShareValue, useSelectSharedValue: shared_state_1.useSelectSharedValue, useDeleteSharedValue: shared_state_1.useDeleteSharedValue, useDashboardNavigationInfo: dashboard_navigation_1.useDashboardNavigationInfo, useQueryData: utils_1.useQueryData, remoteModule: exports.RemoteModule, generateWidgetData: widgetDataGenerator, installedExtensions: getExtensionsList(), getExtension: getExtension, dashboardWidgetInstanceId: dashboardWidgetInstanceId, showNotification: notifications_1.showNotification })))));
});
